/** Тёмная/светлая/авто тема (см. переключатель в SettingsModal). Выбор — в localStorage,
 *  атрибут data-theme на <html> — но хранится именно ПРЕДПОЧТЕНИЕ пользователя (в т.ч. 'auto'),
 *  а на <html> всегда попадает уже РАЗРЕШЁННОЕ 'dark'/'light' (:root[data-theme='light'] в
 *  theme.css переопределяет токены — самого «auto»-варианта в CSS нет). */

const THEME_KEY = 'hc_theme';
export type Theme = 'dark' | 'light' | 'auto';
type ResolvedTheme = 'dark' | 'light';

export function getTheme(): Theme {
  const v = localStorage.getItem(THEME_KEY);
  return v === 'light' || v === 'auto' ? v : 'dark';
}

function systemPrefersDark(): boolean {
  return typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-color-scheme: dark)').matches
    : true;
}

function resolve(theme: Theme): ResolvedTheme {
  return theme === 'auto' ? (systemPrefersDark() ? 'dark' : 'light') : theme;
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', resolve(theme));
  localStorage.setItem(THEME_KEY, theme);
}

/** Вызывается в main.tsx до первого рендера — иначе при светлой теме интерфейс на миг
 *  вспыхивает тёмным, пока React не смонтируется и не применит атрибут. */
export function initTheme(): Theme {
  const theme = getTheme();
  document.documentElement.setAttribute('data-theme', resolve(theme));
  return theme;
}

/** Пока выбрано «Авто» — переприменяет тему при смене системной (тёмное время суток, ручное
 *  переключение в ОС и т.п.), без перезагрузки страницы. Возвращает функцию отписки. */
export function watchSystemTheme(onChange?: () => void): () => void {
  if (typeof window.matchMedia !== 'function') return () => {};
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const handler = () => {
    if (getTheme() !== 'auto') return;
    document.documentElement.setAttribute('data-theme', resolve('auto'));
    onChange?.();
  };
  mq.addEventListener('change', handler);
  return () => mq.removeEventListener('change', handler);
}
